<template>


  <div class="main">
    <div class="header-imgs">
      <img src="@/img/bg@2x.png" alt=""/>
      <img src="@/img/choujiang@2x.png"/>
    </div>

    <div class="grid">
     
      <p @click="myCount()" class="look-jf">查看我的积分:{{currency}}</p>


      <div class="lucky-box">
        <img src="@/img/Frame2366@2x.png" class="lucky-img" />
        <LuckyGrid :width="luckGridHeight" :height="luckGridHeight" class="lucky-canvas" ref="LuckDraw" :prizes="prizes" :blocks="blocks" :buttons="buttons"
          :default-style="defaultStyle" :active-style="activeStyle" @start="startCallBack" @end="endCallBack" />
      </div>
      <div class="doluckDraw">
        <div v-for="(item, index) in doluckDrawData" :key="index" @click="start(item, index)" :class="item.className"
          :ref="'a'+index">{{item.title}}</div>
        <!-- <div @click="start(10)">10连抽</div>
        <div @click="start(20)">20连抽</div> -->
      </div>
      <!--  -->
      本活动与苹果公司(Apple Inc.)无关
    </div>
    
    <!-- <img class="handle2" src="@/img/grid/handle.png"> -->
    <div class="detail">
      <img class="handle1" src="@/img/grid/handle.png" />
      <!-- <div class="listTitel">
        <img src="@/img/grid/lottery_ico_left.png">
        <span>中奖用户</span>
        <img src="@/img/grid/lottery_ico_right.png">
      </div> -->
      <div class="dataList">
        <vue-seamless-scroll :data="userWinningsList" class="seamless-warp" :class-option="optionHover">
          <ul class="item">
            <li v-for="item in userWinningsList" :key="item.id">
              <div class="leftF">{{item.mark}}</div>
              <div class="centerF">{{item.winningInfo}}</div>
              <div class="rightF">{{item.createTime | formatDate}}</div>
            </li>
          </ul>
        </vue-seamless-scroll>

      </div>
    </div>

    <van-dialog v-model="show" title="恭喜你中奖啦" width="308px" height="216" theme="round-button" confirmButtonColor="#ffffff" 
      @confirm="todo()" style="background:#FFAB53">
      <div class="prizeTip">
        <div class="prizeTipImg">
          <img ref="dialogImg" class="dialogImg">
        </div>
        <div class="prizeTipFont">
          <span ref="fontTop" class="fontTop"></span>
          <span ref="fontButtom" class="fontButtom"></span>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="thankShow" title="继续加油哦" width="308px" height="216" theme="round-button" confirmButtonColor="#ffffff" 
      @confirm="todo()" style="background:#FFAB53">
      <div class="prizeTip">
        <div class="prizeTipImg">
          <img ref="dialogImg" class="dialogImg">
        </div>
        <div class="prizeTipFont">
          <span ref="fontTop" class="fontTop"></span>
          <span ref="fontButtom" class="fontButtom"></span>
        </div>
      </div>
    </van-dialog>

      <div class="noticeBar" v-if="showNotice">
      <div>
          <van-notice-bar color="#FF5D21" background="rgba(255,255,255,0.6)" left-icon="volume-o" mode="closeable" >
        {{iphoneWinningMessage}}</van-notice-bar>
      </div>

    </div>
<!-- 
    <div class="noticeBar">
      <van-notice-bar color="#FF5D21" background="rgba(255,255,255,0.6)" left-icon="volume-o" mode="closeable" >
        {{iphoneWinningMessage}}</van-notice-bar>
    </div> -->
   
    <!-- <div class="time">{{content}}</div> -->
  </div>

</template>

<script>
  import {
    LuckyWheel,
    LuckyGrid
  } from 'vue-luck-draw'
  import api from "../api/api";
  import request from '../api/request';
  import {
    Notify
  } from 'vant';
  import {
    Dialog
  } from 'vant';
  import { NoticeBar } from 'vant';
  export default {
    components: {
      LuckyWheel,
      LuckyGrid,
      NoticeBar
      
    },
    data() {
      return {
        prizeIndex: undefined,
        show: false,
        showNotice: false,
        thankShow: false,
        timer: '',
        clock: '',
        prizesList: [],
        luckList: [],
        luckListSplice: [],
        token: undefined,
        currency: 0,
        iphoneWinningMessage: '',
        LotteryNumberLimit:10,
        lucking:false,
        luckDrawNumber: 1,
        doluckDrawData: [{
          'title': '5连抽',
          'className': 'doluckDrawOne',
          'luckDrawNumber': 5,
          'flag': false,
          'img': require('@/img/Frame 2509@2x.png')
        }, {
          'title': '10连抽',
          'className': 'doluckDrawOne',
          'luckDrawNumber': 10,
          'flag': false,
          'img': require('@/img/Frame 2510@2x.png')
        },],
        userWinningsList: [],
        iphoneWinning:[],
        listData: [{
          'title': '你好',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }, {
          'title': '张三',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }, {
          'title': '王麻子',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第四行',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第五行',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第六行',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第七行',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第八行',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第九行',
          'prize': '获得三天靓号服务',
          'date': '2017-12-16'
        }],
        prizes: [],
        // blocks: [{
        //   padding: '33px',
        //   background: 'rgba(0, 0, 0, 0)',
        //   borderRadius: '12px'
        // }, ],
        blocks: [{
          padding: '22px',
        }],
        buttons: [{
          x: 1,
          y: 1,
          background: 'rgba(0, 0, 0, 0)',
          imgs: [{
            src: require('@/img/Frame2508@2x.png'),
            width: '100%',
            top: '0'
          }]
        }],

        defaultStyle: {
          fontColor: '#AFFFD7',
          //fontSize: '12px',
          lineHeight: '13px',
          wordWrap: false
        },
        activeStyle: {
          //  fontColor: '#fff',
        },
        content: '本轮倒计时:', // 按钮里显示的内容
        totalTime: 60,
        luckGridHeight: document.body.clientWidth - 66
      }
    },
    created() {
      let q = this.$route.query;
      //alert(JSON.stringify(q));
      this.token = q.token;
      localStorage.setItem("token", q.token);
      this.getData();
      this.getPrizeUser();
      // this.countTime ();
    },
    computed: {
      optionHover() {
        return {
          singleHeight: 42,
          hoverStop: false
        }
      }
    },
    mounted() {
      console.log(2222)
      this.$refs.LuckDraw.width = "318px"
      this.$refs.LuckDraw.height = "318px"
      this.$refs.LuckDraw.defaultStyle.fontSize = "12px"

      //this.getPrizesList()

    },

    destroyed() {
      clearInterval(this.timer);
      clearInterval(this.clock);
    },
    methods: {
      countDown() {


        this.clock = window.setInterval(() => {

          //获取当前时间
          var date = new Date();
          var now = date.getTime();
          //设置截止时间
          //var endDate = new Date("2022-1-18 15:24:00");
          var end = this.totalTime;
          //时间差
          var leftTime = end - now;
          //定义变量 d,h,m,s保存倒计时的时间
          var d = 0;
          var h = 0;
          var m = 0;
          var s = 0;
          if (leftTime >= 0) {
            d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
            h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
            m = Math.floor(leftTime / 1000 / 60 % 60);
            s = Math.floor(leftTime / 1000 % 60);
          }
          //console.log(d+":"+h+":"+m+":"+s);
          if (h == 0) {
            h = '00';
          }
          if (m == 0) {
            h = '00';
          }
          if (s == 0) {
            h = '00';
          }
          this.content = '本轮倒计时：' + h + ":" + m + ":" + s //这里解决60秒不见了的问题

          //this.content = this.totalTime + 's后重新发送'
          if (leftTime <= 0) { //当倒计时小于0时清除定时器
            window.clearInterval(this.clock)
            this.getData();
            //this.countDown();
          }
        }, 1000)
      },


      todo() {

        let that = this;
        if (that.luckList.length <= 0) {

          return;
        }
        that.$refs.LuckDraw.play()
        that.$refs.LuckDraw.stop(Number(that.luckList[0].id) - 1)

        if (that.luckList.length == 1) {
          setTimeout(() => {
            that.getPrizeUser();
            //that.getSurplusShare();
          }, 5000)
        }


        that.luckListSplice = that.luckList.splice(0, 1);


      },
      getData() {
        let that = this;
        let data = {

        }
        request.getWay(
          api.apiConfig.getAwards, data,
          function (response) {
            that.LotteryNumberLimit = response.data.lotteryNumberLimit;
            that.currency = response.data.score;
            //that.currency = response.data.coinNum;
            that.prizesList = response.data.awardsPool;
            that.totalTime = response.data.endTime;
            that.getPrizesList()
            // request.getWay(
            //   api.apiConfig.getSurplusShare, data,
            //   function (response) {

            //     response.data.forEach((item1, index1) => {

            //       console.log(2323)
            //       that.prizesList.forEach((item, index) => {
            //         if (item1.id + '' === item.id) {
            //           that.prizesList[index].share = item1.surplusShare
            //           return;
            //         }

            //       })


            //     })
            //     that.getPrizesList()
            //   }
            // );
            // that.userWinningsList = response.data.userWinnings;

            that.countDown();
            //console.log(response)
          }
        );

      },

      getPrizeUser() {
        let that = this;
        let data = {

        }
        request.getWay(
          api.apiConfig.getPrizeUser, data,
          function (response) {
            that.userWinningsList = response.data.prizeUserWinning;
            console.log(222,response.data)

             // that.total = response.data.total
            that.list = response.data.iphoneWinning
            if (undefined == that.list || that.list.length <= 0) {
              that.showNotice = false;
            }
            else{
            that.showNotice = true;
            const newIphoneWinning = []
            Object.keys(that.list).forEach(item => {
                newIphoneWinning.push("恭喜用户  "+that.list[item].mark+"抽中"+that.list[item].winningInfo+"一台")
            })
            that.iphoneWinningMessage = newIphoneWinning.join(",");

            }
           
            that.getPrizesList()
          }
        );

      },


      // getSurplusShare() {
      //   let that = this;
      //   let data = {

      //   }

      //   request.getWay(
      //     api.apiConfig.getSurplusShare, data,
      //     function (response) {

      //       response.data.forEach((item1, index1) => {

      //         console.log(2323)
      //         that.prizesList.forEach((item, index) => {
      //           if (item1.id + '' === item.id) {
      //             that.prizesList[index].share = item1.surplusShare
      //             return;
      //           }

      //         })


      //       })
      //       that.getPrizesList()

      //     }
      //   );


      // },




      doAwards() {

        if (this.luckList.length > 0) {
          return Notify({
            type: 'warning',
            message: '正在抽奖中！！！'
          });
          return;
        }

        if (this.lucking) {
          return Notify({
            type: 'warning',
            message: '正在抽奖中！！！'
          });
          return;
        }

        this.lucking = true;

        let that = this;
        let data = {
          second: that.luckDrawNumber
        }
        request.putWay(
          api.apiConfig.doAwards, data,
          function (response) {
            if(response==='异常'){
               that.lucking = false;
               return Notify({
                type: 'warning',
                message: '网络繁忙！！！'
              });
            }
            that.luckList = response.data.awards;
            that.currency = response.data.score;

            if (that.luckList.length <= 0) {
              return Notify({
                type: 'warning',
                message: '未中奖'
              });
            }



            if (that.luckList.length <= 0) {
              clearInterval(that.timer)
              return;
            }
            that.$refs.LuckDraw.play()
            that.$refs.LuckDraw.stop(Number(that.luckList[0].id) - 1)
            that.lucking = false;
            if (that.luckList.length == 1) {
              setTimeout(() => {
                that.getPrizeUser();
                //that.getSurplusShare();
              }, 5000)

            }


            that.luckListSplice = that.luckList.splice(0, 1);





            // that.timer = window.setInterval(() => {

            //   // const a = that.luckList;
            //   //   console.log(a)
            //   if (that.luckList.length <= 0) {
            //     clearInterval(that.timer)
            //     return;
            //   }
            //   that.$refs.LuckDraw.play()
            //   that.$refs.LuckDraw.stop(Number(that.luckList[0].id) - 1)
            //   that.luckList.splice(0, 1);

            // }, 5500)


          }
        );


      },
      myCount() {

        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          //return "ios";
          //alert("ios=window.gotoMyCoin()")
          window.webkit.messageHandlers.gotoMyCoin.postMessage(null)
        } else {
          //return "andriod";
          // alert("android=window.JS_Android.intentMyObi()")
          window.JS_Android.intentMyObi()
        }


      },
      getPrizesList() {
        const prizes = []
        let axis = [
          [0, 0],
          [1, 0],
          [2, 0],
          [2, 1],
          [2, 2],
          [1, 2],
          [0, 2],
          [0, 1]
        ]

        let data = this.prizesList;
        // let data = [{
        //     name: '50经验卷',
        //     img: require('@/img/grid/exp.png'),
        //     top: '69%',
        //   },
        //   {
        //     name: '200经验券',
        //     img: require('@/img/grid/exp.png'),
        //     top: '69%',
        //   },
        //   {
        //     name: '7天靓号服务',
        //     img: require('@/img/grid/beautiful.png'),
        //     top: '69%'
        //   },
        //   {
        //     name: '500经验券',
        //     img: require('@/img/grid/exp.png'),
        //     top: '69%'
        //   },
        //   {
        //     name: '靓号兑换券',
        //     img: require('@/img/grid/10.png'),
        //     top: '69%'
        //   },
        //   {
        //     name: '500经验券',
        //     img: require('@/img/grid/exp.png'),
        //     top: '69%'
        //   },
        //   {
        //     name: '500经验券',
        //     img: require('@/img/grid/exp.png'),
        //     top: '69%'
        //   },
        //   {
        //     name: '7天靓号服务',
        //     img: require('@/img/grid/beautiful.png'),
        //     top: '69%'
        //   },
        // ]
        data.forEach((item, index) => {
          prizes.push({
            x: axis[index][0],
            y: axis[index][1],
            title: item.mark,
            fonts: [{
              text: item.mark ,
              top: '60%',
              fontColor: '#AB745D',
              fontSize: '11px'
            }],
            imgs: [{
                src: require('@/img/grid/cell.png'),
                activeSrc: require(`@/img/grid/active.png`),
                width: '100%',
                height: '100%',
              },
              {
                src: item.img,
                width: '50%',
                height: '50%',
                top: '10%'
              }
            ]
          })
        })
        this.prizes = prizes
      },
      startCallBack() {

        if (this.currency < this.luckDrawNumber * this.LotteryNumberLimit) {
          return Notify({
            type: 'warning',
            message: '积分不足！！！'
          });
        }else{
            this.doAwards();
        }
        

      },
      endCallBack(prize) {
        if(prize.fonts[0].text.split('\n')[0] == '继续加油'){
          this.thankShow = true
        }
        else{
          this.show = true

        }
        this.$nextTick(() => {
          console.log(44444)
          this.$refs.dialogImg.src = prize.imgs[1].src;
          this.$refs.fontTop.innerHTML = prize.fonts[0].text.split('\n')[0];
          this.$refs.fontButtom.innerHTML = this.luckListSplice[0].awardsExplain;


        })

        // Dialog.alert({
        //   title: '恭喜你中奖了',
        //   message: prize.title,
        // }).then(() => {
        //   // on close
        // });
      },
      start(item, index) {
        let that = this;
        that.$refs.LuckDraw.buttons[0].imgs[0].src = item.img;
        let flag = that.doluckDrawData[index].flag;
        if (flag) {
          that.doluckDrawData[index].className = "doluckDrawOne"
          that.doluckDrawData[index].flag = false;
          that.$refs.LuckDraw.buttons[0].imgs[0].src = require("@/img/Frame2508@2x.png");
          that.luckDrawNumber = 1;
        } else {
          that.doluckDrawData.forEach((itemM, indexM) => {
            if (itemM.flag) {
              itemM.flag = false;
              itemM.className = "doluckDrawOne";
            }
          });
          that.doluckDrawData[index].className = "doluckDrawTwo"
          that.doluckDrawData[index].flag = true;
          that.luckDrawNumber = that.doluckDrawData[index].luckDrawNumber;
        }


      }
    }
  }

</script>

<style scoped>
  .main {
    margin: 0px;
    padding: 0px;
    /* height: 753px; */
    background: rgb(247, 246, 246);
    /* background: linear-gradient(to bottom , #FF6E39, #FAAC91,#F3F3F3); */
    padding-top: 95px;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 24px;

  }

  .grid {
    /* width: 320px; */
    /* height: 420px; */
    background-color: white;
    border-radius: 8px;
    /* padding-right: 16px; */
    /* padding-left: 16px; */
    margin-top: -166px;
    padding: 0 18px;
    position: relative;

  }

  .grid .look-jf {
    font-size:14px;
    color:#FF831B;
    text-align: center;
    padding-top: 18px;
  }

  .detail {
    /* width: 335px; */
    /* height: 208px; */
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    /* margin-left: 8px; */
    /* margin-top: 42px; */
    margin-top: 18px;
    
  }

  .lucky-box {
    width: 100%;
    position: relative;
  }

  .lucky-img {
    width: 100%;
    height: 100%;
    vertical-align: bottom;
  }

  .lucky-canvas {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    
  }

  .doluckDraw {
    width: 318px;
    height: 44px;
    margin-top: 12px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 12px;
  }

  .doluckDrawOne {
    width: 150px;
    height: 44px;
    /* background: #f3f7ff; */
    /* border-radius: 12px; */
    /* box-shadow: 1px -2px 2px 0px #AB745D inset; */

    font-size: 14px;
    line-height: 43px;
    /* font-family: PingFang SC, PingFang SC-Regular; */
    font-weight: 400;
    text-align: CENTER;
    color: #f6ab90;
    background: url(../img/Frame2334@2x.png);
    background-size: 100%;
  }

  .doluckDrawTwo {
    width: 150px;
    height: 44px;
    /* background: #f6ab90; */
    /* border-radius: 12px; */
    /* box-shadow: 1px -2px 2px 0px #cfddff inset; */

    font-size: 14px;
    line-height: 43px;
    /* font-family: PingFang SC, PingFang SC-Regular; */
    font-weight: 400;
    text-align: CENTER;
    color: #f4f5f8;
    background: url(../img/Frame9@2x.png);
    background-size: 100%;

  }

  .myOB {
    margin-top: 18px;
    width: 319px;
    height: 40px;
    background: #4C86FF;
    border-radius: 81px 81px 81px 81px;
    opacity: 1;
  }

  .myOB>a {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;

  }

  .title {
    width: 300px;
    height: 77px;
    position: absolute;
    left: 37px;
    top: 8px;
    z-index: 1;
  }

  .title1 {
    left: 20px;
    top: 20px;
    z-index: 1;
    position: absolute;
  }
  .title2 {
    left: 280px;
    top: 25px;
    z-index: 1;
    position: absolute;
  }

  .handle1 {
    margin-top: -8px;
  }

  .handle2 {
    width: 12px;
    height: 40px;
    position: relative;
    left: 279px;
    top: 562px;
  }

  .listTitel {
    padding-top: 31px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: center;
    color: #0e65e8;

  }

  .listTitel>img {
    width: 35px;
    height: 4px;
  }

  .dataList {
    /* width: 320px; */
    height: 180px;
    padding-top: 14px;
    padding-bottom: 20px;
    padding-left: 8px;
    padding-right: 8px;
    /* margin: 0px 6px 0px 0px; */
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
  }

  .seamless-warp {
    height: 100%;
    overflow: hidden;
  }

  li {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 13px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #333333;
  }

  .leftF {
    width: 110px;

    text-align: left;
  }

  .centerF {
    text-align: center;

  }

  .rightF {
    flex-grow: 1;
    text-align: right;

  }

  li>div {

    height: 40px;

  }

  .prizeTip {
    width: 260px;
    height: 90px;
    margin: 0 auto;
    background: url(../img/grid/popups.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: start;

  }

  .thankTip {
    width: 260px;
    height: 90px;
    margin: 0 auto;
    
    /* background: url(../img/grid/jiayou@2x.png);
    background-repeat: no-repeat;
    background-position: absolute;
    background-size: 25%;
    background-position-x: 10px;
    background-position-y: -15px; */



    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: start;

  }

  .thankWord{
    top: -30px;
    left: 40px;
    position: relative;
    font-size:14px
  }

  .thankImg {
    width: 60px;
    height: 60px;
    position: relative;
    top: -70px;
    left: -200px;

  }

  .thankWord{
    width: 224px;
    height: 20px;
    font-size: 14px;
    text-align: center;

  }

  .dialogImg {
    width: 39px;
    height: 40px;
  }

  .prizeTipImg {
    margin-top: 27px;
    margin-left: 19px;
  }

  .prizeTipFont {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: start;
    margin-left: 17px;
  }

  .fontTop {
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: LEFT;
    color: #333333;
    margin-top: 23px;
  }

  .fontButtom {
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: LEFT;
    color: #333333;
    margin-top: 4px;
  }

  .van-dialog--round-button .van-dialog__footer {
    position: relative;
    height: auto;
    padding: 29px 49px 16px;
  }

  .time {

    height: 20px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 16px;
    margin-top: 28px;
  }
  
  .header-imgs {
    margin-left: -12px;
    margin-top: -95px;
    width: calc(100% + 24px);
    position: relative;
  }
  .header-imgs img:first-of-type {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  .header-imgs img:last-of-type {
    position: absolute;
    left: 0;
    top: 0;
    width: calc(100% - 72px);
    margin:0 36px;
    margin-top: calc(50% - 120px);
    transform: translateY(-50%);
  }
  .noticeBar{
    width: 320px;
    height: 10px;
    font-size: 14px;
    position:fixed;
    top:2px;
    left:25px;
  }
  .van-notice-bar{
  width: 300px;
  height: 32px;
  top:5px;
  background: rgba(255,255,255,0.6);
  border-radius: 43px 43px 43px 43px;
  opacity: 1;

  }
  
</style>



// WEBPACK FOOTER //
// src/components/luckyGrid.vue